const defaultState = {
  loading: false,
  timeRange: {},
  settings: {},
  metadata: {},
  derivedQuestions: {},
  exportList: {},
  analyze: {},
  filters: {},
  subpopulations: {},
  weightings: {}
};

const TEST_ACTION = 'TA/ACTIONS/TEST_ACTION';

export const testAction = () => {
  return {type: TEST_ACTION, data: 'test'};
};


const reportReducer = (state = defaultState, action) => {
  switch (action.type) {
    case TEST_ACTION:
      return state;
    default:
      return state;
  }
};

export default reportReducer;



// WEBPACK FOOTER //
// ./common/ducks/index.js